import { BaseComponent } from 'components/BaseComponent';
import { ICartModel } from 'interfaces/ICartModel';
import { IProductConfig } from 'interfaces/IProductData';
import React from 'react';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';

import { Header } from './Header';
import MultiStep from './MultiStep/index';
import Hidden from '@material-ui/core/Hidden';
import { ITemplateState, IPayProps } from 'components/Cart';
import SingleStep from './SingleStep/index';
import OneClickBuy from './OneClickBuy';
import Language from 'components/Language';
import ExitPopUp from 'components/ExitPopUp';

const styles = require('./theme.css');

interface IState extends ITemplateState {
  config: IProductConfig;
  model: ICartModel;
}

export default class MobileTheme extends BaseComponent<IState, IPayProps> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ config: null }, cartService.getConfig());
    this.bindModel(paymentService.getCart());
  }

  render() {

    if (!this.state) {
      return '';
    }

    const { cart } = this.state;

    const topBanner = cart.config.template.media.bannerTop;
    const product = cart.products[0];

    return (
      <div className={`${styles.component} theme-background-image backgroundImage '`}>
        <Language />

        {topBanner
          ? <Header topBanner={topBanner} />
          : null
        }

        {cart.config.isOneClick
          ? <OneClickBuy onPay={this.props.onPay} />
          : <div className={`container ${!topBanner && 'padding-top-language'}`}>
            <Hidden mdUp={true}>
              <MultiStep product={product} onPay={this.props.onPay} />
            </Hidden>
            <Hidden smDown={true}>
              {cart.config.exitModal && !paymentService.hasPayment() ?
                <ExitPopUp /> :
                null
              }
              <SingleStep onPay={this.props.onPay} />
            </Hidden>
          </div>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/index.tsx